import{__exports as o}from"../../../../../_virtual/crypto.js";Object.defineProperty(o,"__esModule",{value:!0}),o.crypto=void 0,o.crypto="object"==typeof globalThis&&"crypto"in globalThis?globalThis.crypto:void 0;export{o as default};
